import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { TrustBar } from '../components/TrustBar';
import { ContrastSection } from '../components/ContrastSection';
import { StickyCTA } from '../components/StickyCTA';
/* Lazy-load only truly below-fold sections to reduce network waterfall.
   Grouped into two Suspense boundaries to minimize chunk requests. */
const ForWhomSection = lazy(() => import('../components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const ContentPreview = lazy(() => import('../components/ContentPreview').then(m => ({
  default: m.ContentPreview
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const ExpertSection = lazy(() => import('../components/ExpertSection').then(m => ({
  default: m.ExpertSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('../components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  return <main className="w-full min-h-screen bg-bg-main font-inter selection:bg-primary/30" data-id="element-219">
      {/* Above-fold: eagerly loaded for fastest FCP/LCP */}
      <HeroSection data-id="element-220" />
      <TrustBar data-id="element-221" />
      <ContrastSection data-id="element-222" />

      {/* Near-fold: lazy but grouped */}
      <Suspense fallback={null} data-id="element-223">
        <ForWhomSection data-id="element-224" />
        <ContentPreview data-id="element-225" />
        <BonusSection data-id="element-226" />
        <PricingSection data-id="element-227" />
      </Suspense>

      {/* Far below fold */}
      <Suspense fallback={null} data-id="element-228">
        <GuaranteeSection data-id="element-229" />
        <ExpertSection data-id="element-230" />
        <Footer data-id="element-231" />
        <SocialProofPopup data-id="element-232" />
      </Suspense>

      <StickyCTA data-id="element-233" />
    </main>;
}